<template>
  <div class="itemBox">
    <div class="imgBlock" style="pointer-events: none">
      <ComboProductImage
        :scale="0.6"
        :components="menu.components"
      ></ComboProductImage>
    </div>
    <div class="informBlock">
      <div class="headerBlock">
        <div
          class="itemName text"
          :class="{ 'itemName-customColor': shouldOverwriteColor() }"
        >
          {{ name }}
        </div>
        <div class="itemAction">
          <count-block :basketitem="menu" @add="add" @sub="sub"></count-block>
          <div class="itemPrice" :class="{ invisible: noprices }">
            <div
              :class="{
                stroke: globalCoupon || discount
              }"
            >
              {{ menuPriceWithoutDeposit }}
            </div>
            <div class="couponPrice" v-if="globalCoupon || discount">
              {{ couponPrice }}
            </div>
          </div>
        </div>
      </div>
      <div class="collapsedBlock">
        <div class="optionBlock">
          <div
            class="optionItem"
            v-for="(comp, index) in components"
            :key="index"
          >
            <div class="optionLine">
              <div class="optionText">
                <div class="optionTitle">
                  {{ itemName(comp.selected) }}
                  <span v-if="showMenuComponentPrice(comp.selected, index)"
                    >({{ menuComponentPrice(comp.selected, index) }})</span
                  >
                  <span v-if="comp.selected.deposit" class="depositBlock">
                    {{ $t("order.deposit") }} +{{
                      toPrintable(comp.selected.deposit)
                    }}
                  </span>
                </div>

                <div
                  v-if="!comp.selected.scanned && !isV2EditOrder"
                  class="optionEdit"
                  @click="edit(comp.selected, menu.uid, comp.id)"
                >
                  <span class="optionImgEdit" />
                </div>
              </div>
            </div>
            <ingredients-block
              :ingredients="ingredients(comp.selected)"
              :item="comp.selected"
              :noprices="noprices"
            ></ingredients-block>
            <extras-block
              :scanned="comp.selected.scanned"
              :extras="extras(comp.selected)"
              @editExtra="editExtra(comp.selected, $event)"
            ></extras-block>
          </div>
        </div>
      </div>
    </div>
    <div class="editRemoveBlock">
      <edit-button v-if="isV2EditOrder" @edit="editMenu(menu.uid)" />
      <remove-button @remove="del" />
    </div>
  </div>
</template>

<script>
import { cssVarValue } from "@/utils/helpers";
import { isEmpty } from "lodash";
import CountBlock from "./common/countBlock";
import ComboProductImage from "../../combo/ComboProductImage";
import {
  COUPON_CATEGORIES,
  hideZero,
  ingredientPrice,
  isPricingTypeFixed,
  isPricingTypeSum,
  toCalculatable,
  toPrintable
} from "@/utils/pricing";
import IngredientsBlock from "./common/ingredientsBlock";
import ExtrasBlock from "./common/extrasBlock";
import { getTranslation } from "@/utils/helpers";
import { mapGetters } from "vuex";
import RemoveButton from "@/components/order/listItems/common/removeButton.vue";
import EditButton from "@/components/order/listItems/common/editButton.vue";
import { isV2EditOrder } from "@/utils/templateSettings";

export default {
  name: "MenuItem",
  components: {
    EditButton,
    RemoveButton,
    IngredientsBlock,
    CountBlock,
    ComboProductImage,
    ExtrasBlock
  },
  computed: {
    ...mapGetters({ coupons: "COUPONS" }),
    menuPriceWithoutDeposit() {
      if (isPricingTypeFixed(this.menu))
        return this.menu.vatDetails.grossNoDiscounts.toPrintable();
      return this.menu.vatDetails.grossBasePrice.toPrintable();
    },
    name() {
      //this menu is actually a product - that variable naming is bad :(
      // TODO: the menu id was overwritten by some stupid logic that we got rid of. Now the Menu translations actually get shown.
      // This is bad since menu names are poorly/not translated we want to actually use the fallback for menus for now.
      /*return getTranslation(
        this.$store,
        "Menu",
        "display_name",
        this.menu.id,
        this.menu.name
      );*/
      return this.menu.name;
    },
    canEditItem() {
      return isEmpty(this.item.ingredients);
    },
    components() {
      if (this.menu.components) {
        return this.menu.components;
      }
      return [];
    },
    discount() {
      return this.menu.discount;
    },
    globalCoupon() {
      let percent_off_global = this.coupons.find(
        c => c.data.c === COUPON_CATEGORIES.PERCENT_OFF
      );
      if (percent_off_global) {
        return {
          ...percent_off_global,
          data: {
            ...percent_off_global.data,
            c: COUPON_CATEGORIES.PERCENT_OFF_CATEGORY
          },
          deletable: false
        };
      }
      return null;
    },
    couponPrice() {
      return this.menu.vatDetails.grossPaid.toPrintable();
    },
    isV2EditOrder
  },
  methods: {
    shouldOverwriteColor() {
      let customColor = cssVarValue(
        "--component_order_listitems_MenuItem_itemName-customColor_color"
      );
      return !isEmpty(customColor);
    },
    showMenuComponentPrice(productInMenu, index) {
      return (
        index === 0 ||
        isPricingTypeFixed(this.menu) ||
        isPricingTypeSum(this.menu) ||
        (index > 0 && productInMenu.menu_offset_price != 0)
      );
    },
    menuComponentPrice(productInMenu, index) {
      if (
        index === 0 ||
        isPricingTypeFixed(this.menu) ||
        isPricingTypeSum(this.menu)
      ) {
        if (productInMenu.selectedSize) {
          return toPrintable(
            toCalculatable(productInMenu.price) +
              toCalculatable(productInMenu.selectedSize.offset_price)
          );
        } else {
          return toPrintable(productInMenu.price);
        }
      }
      if (index > 0 && productInMenu.menu_offset_price !== 0) {
        if (productInMenu.selectedSize) {
          return toPrintable(
            toCalculatable(productInMenu.menu_offset_price) +
              toCalculatable(productInMenu.selectedSize.offset_price)
          );
        } else {
          return toPrintable(productInMenu.menu_offset_price);
        }
      }
    },
    toPrintable,
    ingredientPrice,
    hideZero,
    add() {
      this.$emit("add", this.menu);
    },
    sub() {
      this.$emit("sub", this.menu);
    },
    editExtra(item, extra) {
      this.$emit("editExtra", { item: item, extra });
    },
    edit(item, uid, component_id) {
      this.$emit("edit", { item, uid, component_id });
    },
    editMenu(uid) {
      this.components.some(comp => {
        if (comp) {
          this.$emit("edit", { comp, uid, component_id: comp.id });
          return true;
        }
      });
    },
    del() {
      this.$emit("del", this.menu);
    },
    itemName(item) {
      let basename = getTranslation(
        this.$store,
        "Product",
        "display_name",
        item.id,
        item.name
      );
      if (item.selectedSize) {
        let size = item.selectedSize;
        let size_name = getTranslation(
          this.$store,
          "Size",
          "display_name",
          size.id,
          size.size
        );
        basename += ` (${size_name})`;
      }
      return basename;
    },
    ingredients(item) {
      if (!isEmpty(item.ingredients)) {
        return item.ingredients;
      }
      return { default: [] };
    },
    extras(item) {
      if (!isEmpty(item.selectedExtras)) {
        return item.selectedExtras;
      }
      return [];
    },
    depositInMenu() {
      let deposit = 0;
      if (this.menu.components) {
        let deposits = this.menu.components.map(comp => comp.selected.deposit);
        deposits.forEach(d => {
          if (d) {
            deposit += toCalculatable(d);
          }
        });
      }
      console.log("depositInMenu deposit: " + deposit);
      return deposit;
    }
  },
  props: {
    menu: Object,
    noprices: Boolean
  }
};
</script>

<style scoped>
.invisible {
  opacity: 0;
}
.depositBlock {
  color: #252525;
  font-family: var(
    --component_order_listitems_MenuItem_depositBlock_font-family
  );
  font-size: var(--component_order_listitems_MenuItem_depositBlock_font-size);
  font-weight: normal;
  font-style: italic;
}
.imgBlock {
  width: 25%;
  flex: 0 0 25%;
  margin-top: -25px;
  display: flex;
  pointer-events: none;
  align-items: center;
  justify-content: center;
}
.informBlock {
  width: 100%;
  flex: 1;
}
.headerBlock {
  display: flex;
  justify-content: space-between;
}
.itemAction {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.itemName {
  font-family: var(--component_order_listitems_MenuItem_itemName_font-family);
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1.1px;
}
.itemName-customColor {
  color: var(--component_order_listitems_MenuItem_itemName-customColor_color);
}

.itemPrice {
  width: var(--component_order_listitems_MenuItem_itemPrice_width);
  justify-content: flex-end;
  font-family: var(--component_order_listitems_MenuItem_itemPrice_font-family);
  color: #3d3d3d;
  font-size: 22px;
  display: flex;
  align-items: var(--component_order_listitems_MenuItem_itemPrice_align-items);
  padding-right: 10px;
  flex-direction: column;
}
.itemPrice .stroke {
  text-decoration: line-through;
}

.couponPrice {
  color: #62a200;
  text-decoration: none currentcolor solid;
}

.optionText {
  display: flex;
  flex-wrap: wrap;
}

.optionImgEdit {
  background-image: var(
    --component_order_listitems_MenuItem_optionImgEdit_background-image
  );
  background-size: contain;
  display: inline-block;
  width: 16px;
  height: 16px;
}

.optionItem {
  display: flex;
  flex-direction: column;
}
.optionTitle {
  font-family: var(
    --component_order_listitems_MenuItem_optionTitle_font-family
  );
  font-size: 17px;
  letter-spacing: var(--app_letter-spacing_dense);
  color: #252525;
}

.optionEdit {
  margin: 2px 5px 0 10px;
}

.optionBlock {
  display: flex;
  width: 100%;
  min-height: 135px;
  flex-direction: column;
  gap: 6px;
}
.optionLine {
  display: flex;
  flex-direction: row;
}
</style>
